import { useTheme } from '@/lib/theme';

function VaderHilt() {
  return (
    <svg className="theme-saber__hilt theme-saber__hilt--vader" viewBox="0 0 86 32" aria-hidden="true">
      <rect x="2" y="10" width="10" height="12" rx="1.5" fill="#0c0d0f" />
      <rect x="3" y="11" width="8" height="2" fill="#8b939c" />
      <rect x="12" y="8" width="38" height="16" rx="1" fill="#121417" />
      <rect x="14" y="10" width="34" height="2" fill="#2a3038" />
      <rect x="14" y="14" width="34" height="2" fill="#2a3038" />
      <rect x="14" y="18" width="34" height="2" fill="#2a3038" />
      <rect x="48" y="6" width="14" height="20" rx="1" fill="#0c0d0f" />
      <rect x="50" y="8" width="10" height="7" fill="#1b2026" />
      <rect x="52" y="10" width="6" height="3" fill="#c4001a" />
      <rect x="62" y="7" width="8" height="18" fill="#b7c0c8" />
      <rect x="64" y="9" width="4" height="14" fill="#8b949e" />
      <path d="M70 6h12l-3 10 3 10H70V6Z" fill="#c5ced6" />
      <path d="M72 8h7l-2 8 2 8h-7V8Z" fill="#9aa3ad" />
    </svg>
  );
}

function LukeHilt() {
  return (
    <svg className="theme-saber__hilt theme-saber__hilt--luke" viewBox="0 0 86 32" aria-hidden="true">
      <circle cx="8" cy="16" r="7" fill="#d5dde4" />
      <circle cx="8" cy="16" r="4" fill="#1a1f26" />
      <rect x="14" y="9" width="40" height="14" rx="2" fill="#d7dee5" />
      <rect x="20" y="9" width="4" height="14" fill="#1a1f26" />
      <rect x="32" y="9" width="4" height="14" fill="#1a1f26" />
      <rect x="44" y="9" width="3" height="14" fill="#1a1f26" />
      <rect x="50" y="6" width="10" height="20" rx="1" fill="#c9d2da" />
      <circle cx="55" cy="12" r="2.4" fill="#c4001a" />
      <rect x="60" y="8" width="22" height="16" fill="#dce3ea" />
      <rect x="63" y="10" width="3" height="12" fill="#8b949e" />
      <rect x="69" y="10" width="3" height="12" fill="#8b949e" />
      <rect x="75" y="10" width="3" height="12" fill="#8b949e" />
    </svg>
  );
}

export function ThemeSaber() {
  const { phase, toggle } = useTheme();

  return (
    <button type="button" className="theme-saber" data-phase={phase} aria-label="Toggle theme" onClick={toggle}>
      <span className="theme-saber__track">
        <VaderHilt />
        <LukeHilt />
        <span className="theme-saber__blade">
          <span className="theme-saber__core" />
        </span>
      </span>
    </button>
  );
}
